import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { NavLink, useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { ArrowLeft, RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import { useHtzAhuComponentCatalogShowQuery } from "@/services/backend/htz/ahu/api/ahu-component-catalog-api";
import { AhuComponentCatalogItemTable } from "@/services/backend/htz/ahu/components/ahu-component-catalog-item-table";
import { PutAhuComponentCatalogItemDialog } from "@/services/backend/htz/ahu/components/put-ahu-component-catalog-item-dialog";
import { Button } from "@/shared/components/ui/button";

export function AhuComponentCatalogRoute() {
  const { ahuComponentCatalogId } = useParams();

  const {
    data: catalog,
    isLoading,
    error,
  } = useHtzAhuComponentCatalogShowQuery({
    id: ahuComponentCatalogId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex space-x-4">
            <RefreshCw className="animate-spin" />
            <span>{t("Lade Katalog")}</span>
          </CardTitle>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>
            <NavLink to="./..">
              <Button variant="outline" size="sm" className="m-0 mb-4">
                <ArrowLeft className="mr-2 h-4 w-4" />
                <span>{t("Übersicht")}</span>
              </Button>
            </NavLink>
            <div>{catalog!.name}</div>
          </CardTitle>
          <CardDescription>
            {t("Vorlagen für Komponenten einer RLT-Anlage.")}
          </CardDescription>
          <CardAction>
            <PutAhuComponentCatalogItemDialog catalogId={catalog!.id} />
          </CardAction>
        </CardHeader>
        <CardContent>
          <AhuComponentCatalogItemTable catalog={catalog!} />
        </CardContent>
      </Card>
    </div>
  );
}
